import React, { Component } from 'react';
import { Row, Col, Button, Card, CardBody, CardTitle, CardSubtitle, CardText } from 'reactstrap';
import MaterialIcon from 'material-icons-react';
import i18n from '../../../i18next';

import { convertToLowerCase } from '../../../utils/CommonUtils';
import {
    COMMON_BTN_COPY,
    COMMON_BTN_EDIT,
    COMMON_BTN_DELETE,
    PRICE_DISCOUNT,
    COMBO_DEAL
} from '../../../utils/Constants';
import PopoverItem from '../../common/PopoverItem';

class PromotionCard extends Component {
    renderButtons() {
        const { btnStyle } = this.props.styles;
        const buttons = [COMMON_BTN_COPY, COMMON_BTN_EDIT, COMMON_BTN_DELETE];

        return buttons.map((button, i) => {
            let selectEventHandler = null;

            if (button === buttons[0]) {
                selectEventHandler = (button === buttons[0]) ? this.props.onCopy : '';
            } else if (button === buttons[1]) {
                selectEventHandler = (button === buttons[1]) ? this.props.onEdit : '';
            } else {
                selectEventHandler = (button === buttons[2]) ? this.props.onDelete : '';
            }

            return <Button key={i} style={btnStyle} color="link" onClick={selectEventHandler}>{`${convertToLowerCase(i18n.t(`common:buttons.${button}`))}`}</Button>;
        });
    }

    isPromotionExpired(startDate, endDate, active, inactive) {
        let today = new Date();
        let dd = today.getDate();
        let mm = today.getMonth() + 1; //January is 0!
        let yyyy = today.getFullYear();

        let endDateCopy = endDate.split('-');
        const endDateDay = endDateCopy[0];
        const endDateMonth = endDateCopy[1];
        const endDateYear = endDateCopy[2];

        if (yyyy >= parseInt(endDateYear) && mm >= parseInt(endDateMonth) && dd > parseInt(endDateDay)) {
            return inactive;
        } else if (yyyy >= parseInt(endDateYear) && mm > parseInt(endDateMonth)){
            return inactive;
        } else if (yyyy > parseInt(endDateYear)) {
            return inactive;
        }

        return active; 
    }

    promotionDealType(discountType, hasIcon) {
        switch(discountType) {
            case PRICE_DISCOUNT:
                if (hasIcon) return "local_offer";
                return i18n.t('screens:promotionsScreen.summaryPrice');
            case COMBO_DEAL:
                if (hasIcon) return "fastfood";
                return i18n.t('screens:promotionsScreen.summaryCombo');
            default:
                if (hasIcon) return "free_breakfast";
                return i18n.t('screens:promotionsScreen.summaryProduct');
        }
    }

    render() {
        const { name, validity, discountType } = this.props.promotion;
        const { card, cardBody, cardTitle, cardTitleExpired, cardSubtitle, cardSubtitleExpired,
            dealType, btnColumn, cardText, cardTextExpired, dealTypeText, dealTypeTextExpired,
            iconColor, iconColorExpired } = this.props.styles;

        return (
            <Col sm={3} className="promotion-card">
                <Card style={card}>
                    <CardBody style={cardBody}>
                        <Row>
                            <Col sm={8}>
                                <CardTitle className="longerNamesStyle" style={this.isPromotionExpired(validity.startDate, validity.endDate, cardTitle, cardTitleExpired)}>
                                    <PopoverItem id={'promotionName' + this.props.index} item={name} styles={this.props.styles}/>
                                </CardTitle>
                            </Col>
                            <Col sm={4}>
                                <CardSubtitle style={this.isPromotionExpired(validity.startDate, validity.endDate, cardSubtitle, cardSubtitleExpired)}>
                                    {this.isPromotionExpired(validity.startDate, validity.endDate, i18n.t('common:buttons.active'), i18n.t('screens:promotionsScreen.inactiveCard'))}
                                </CardSubtitle>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <CardText style={this.isPromotionExpired(validity.startDate, validity.endDate, cardText, cardTextExpired)}>
                                    {`${i18n.t('screens:preparationTimes.from')} ${validity.startDate} ${i18n.t('screens:preparationTimes.to')} ${validity.endDate}`}
                                </CardText>
                            </Col>
                        </Row>
                        <Row>
                            <Col sm={6} style={dealType}>
                                <span><MaterialIcon icon={this.promotionDealType(discountType, true)} color={this.isPromotionExpired(validity.startDate, validity.endDate, iconColor, iconColorExpired)} size={16} /></span>&nbsp;
                                <CardText style={this.isPromotionExpired(validity.startDate, validity.endDate, dealTypeText, dealTypeTextExpired)}>
                                    {this.promotionDealType(discountType, false)}
                                </CardText>
                            </Col>
                            <Col sm={6} style={btnColumn}>
                                {this.renderButtons()}
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
            </Col>
        );
    }
}

export default PromotionCard;


// WEBPACK FOOTER //
// ./src/components/restaurants/promotions/PromotionCard.js